<template>
  <div style="padding:10px;">
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white" height="150">
      <van-swipe-item v-for="item in lunbotu" :key="item">
        <van-image
          fit="contain"
          radius="10"
          :src="item.tupian"
        ></van-image>
      </van-swipe-item>
    </van-swipe>
    <div class="tongzhibeijing" v-if="gonggao != ''">
      <div class="tongzhizuoce">
        <svg data-v-83f175ba="" t="1745562851000" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3605" width="20" height="20"><path data-v-83f175ba="" d="M808 712l-48-108.8V448c0-102.4-65.6-195.2-160-232-3.2-44.8-41.6-80-88-80s-83.2 35.2-88 80c-96 36.8-160 129.6-160 232v155.2l-48 108.8c-6.4 14.4-4.8 30.4 3.2 43.2 8 12.8 22.4 20.8 38.4 20.8h508.8c16 0 30.4-8 38.4-20.8s9.6-30.4 3.2-43.2z m-547.2 16l51.2-115.2V448c0-88 59.2-166.4 144-192l19.2-6.4-3.2-20.8V224c0-22.4 17.6-40 40-40s40 17.6 40 40v6.4l-3.2 20.8 19.2 6.4c84.8 25.6 144 104 144 192v164.8l51.2 115.2H260.8zM512 880c44.8 0 80-35.2 80-80H432c0 44.8 35.2 80 80 80z" fill="#272636" p-id="3606"></path></svg>
        <span style="font-size: .9rem;font-weight: 600;color: #606266">最新动态</span>
      </div>
      <div>
        <van-notice-bar
         scrollable 
         color="#737579"
         background="#ffffff"
         :text="gonggao" style="height: 20px;"/>
      </div>
    </div>
    <van-sticky>
      <div class="sousuobeijing">
        <div class="">
          <van-search 
            shape="round" 
            v-model="datainfo.guanjianci" 
            placeholder="输入编号或关键词搜索" 
            @search="onSearch"
            @cancel="onCancel"
            style="height: 35px;"/>
        </div>
        <div class="sousuoyouce">
          <van-button round icon="search" type="success" size="small" @click="onSearch">搜索</van-button>
        </div>
        <div class="sousuoyouce">
          <van-badge :content="shaixuanshu" offset="[5px, 10px]" v-if="shaixuanshu > 0">
            <van-button round icon="filter-o" type="default" size="small" @click="showShaixuan">筛选</van-button>
          </van-badge>
          <van-button v-else round icon="filter-o" type="default" size="small" @click="showShaixuan">筛选</van-button>
        </div>
      </div>
    </van-sticky>
    
  
    <van-list
      v-model:loading="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      style="margin: 10px 10px;"
    >
      <van-row :gutter="[10, 10]">
        <van-col span="12"  v-for="item in list" :key="item" :title="item">
          <div style="position:relative;background: #ffffff;border-radius: 10px;overflow: hidden;padding: 0px 0px 10px 0px;" @click="goToPage(item.id)">
            <van-tag style="position:absolute;top: 10px;right: 10px;z-index: 1;background: #27ae60cc;padding: 3px 8px;border-radius: 3px;font-size: 12px;font-weight: 500;color: #fff;">{{item.bianhao}}</van-tag>
            <img src="https://oss.xuxug.com/static/images/288.jpg" alt="" class="goods_item_img" v-if="item.img == ''">
            <img :src="item.img" alt="" class="goods_item_img" v-else-if="item.img.indexOf('https') != -1">
            <img :src="'https://oss.xuxug.com/uploads/tupian/fzshangpin/'+item.img" alt="" class="goods_item_img" v-else>
            <div class="goodsname">
              <van-text-ellipsis rows="2" :content="item.title" />
            </div>
            
            <div style="display: grid;grid-template-columns: 1fr 1fr;">
              <div style="text-align: left;padding: 0px 10px;font-size: 16px;font-weight: 600;color: #ff5e5e;white-space: nowrap;">¥{{item.shoujia}}</div>
              <div>
                <van-tag style="background: linear-gradient(45deg, #6a6666, #413c3c);color: #e1c280;">找回包赔</van-tag>
              </div>
            </div>
            <div style="display: grid;grid-template-columns: 1fr 1fr;margin-top: 5px;">
              <!-- <div style="text-align: left;padding: 0px 10px;font-size: 12px;color: #999;gap: 1px;">{{ daysAgo(item.zuihou_caozuo_time) }}</div> -->
              <div></div>
              <div>
                <van-tag style="background: linear-gradient(45deg, #8e8afa, #6966f9);">平台自营</van-tag>
              </div>
            </div>
          </div>
        </van-col>
      </van-row>
    </van-list>
    <van-popup
      v-model:show="showBottom"
      round
      closeable="true"
      :safe-area-inset-top=true
      position="bottom"
      :style="{ height: '70%' }"
    >
      <div style="margin-top:5px;">筛选</div>
      <div style="margin:10px 0px;font-size:14px;color:#ff0000;">系统会自动保存最后一次筛选记录</div>
      <div style="position:absolute;top:80px;bottom:60px;left:0px;right:0px;">
        <van-tree-select
          v-model:active-id="activeIds"
          v-model:main-active-index="activeIndex"
          height="100%"
          :items="biaoqianinfo"
          @click-nav="huoquleixing"
          style="text-align: left;font-weight: 300;"
        >
        <template #content>
          <div v-for="(youceitem, index) in biaoqianinfo" :key="index">
            <div v-if="activeIndex === index" style="padding:0px 10px;font-weight:bolder;">
              <div v-if="activeIndex === 0">
                <!-- <div style="text-align: left;font-size:14px;color:#000000;">编号</div>
                <div style="display: grid;grid-template-columns: 1fr;margin:10px 0px;">
                  <div style="color: #000000;font-size: 14px;text-align: left;border: 0.5px solid #ebedf0;border-radius:10px;overflow: hidden;height:35px;">
                    <van-field v-model="datainfo.bianhao" placeholder="请输入编号搜素" style="padding:5px 10px;"/>
                  </div>
                </div> -->

                <div style="margin-top:20px;text-align: left;font-size:14px;color:#000000;">价格范围</div>
                <div style="display: grid;grid-template-columns: 1fr 30px 1fr;margin:10px 0px;">
                  <div style="color: #000000;font-size: 14px;text-align: left;border: 0.5px solid #ebedf0;border-radius:10px;overflow: hidden;height:35px;">
                    <van-field v-model="datainfo.zuidijia" type="digit" placeholder="最低价格" style="padding:5px 10px;"/>
                  </div>
                  <div style="display: flex;justify-content: center;align-items: center;">---</div>
                  <div style="color: #000000;font-size: 14px;text-align: left;border: 0.5px solid #ebedf0;border-radius:10px;overflow: hidden;height:35px;">
                    <van-field :size="normal" v-model="datainfo.zuigaojia" type="digit" placeholder="最高价格" style="padding:5px 10px;" />
                  </div>
                </div>
                <div style="margin-top:20px;text-align: left;font-size:14px;color:#000000;">排序方式</div>
                <van-radio-group v-model="datainfo.paixu">
                  <van-radio name="0" style="margin-top:15px;">默认排序</van-radio>
                  <van-radio name="1" style="margin-top:15px;">价格从低到高</van-radio>
                  <van-radio name="2" style="margin-top:15px;">价格从高到低</van-radio>
                </van-radio-group>
              </div>
              <div v-else-if="youceitem.sanji == '1'">
                <div style="padding:5px;font-size: 14px;text-align: left;" v-for="(items, key) in youceitem.children" :key="key">
                  <div v-if="shuzuchangdu(items.sanji_biaoqian) > 0" style="text-align: left;font-size:16px;color:#000000;">{{items.text}}</div>
                  <div v-if="shuzuchangdu(items.sanji_biaoqian) > 0" style="margin:10px 0px; display: grid;grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));">
                    <div style="padding:5px;font-size: 14px;text-align: left;" v-for="(item, k) in items.sanji_biaoqian" :key="k">
                      <van-button v-if="isValueInArray(youceitem.check,item.id)" plain type="warning" size="small" block style="margin:0px;" @click="xuanzhongitem(index,item.id)">{{item.text}}</van-button>
                      <van-button v-else type="default" size="small" block style="margin:0px;" @click="xuanzhongitem(index,item.id)">{{item.text}}</van-button>
                    </div>
                  </div>
                  <div v-else style="margin:0px;">
                    <van-button v-if="isValueInArray(youceitem.check,items.id)" plain type="warning" size="small" block style="margin:0px;" @click="xuanzhongitem(index,items.id)">{{items.text}}</van-button>
                    <van-button v-else type="default" size="small" block style="margin:0px;" @click="xuanzhongitem(index,items.id)">{{items.text}}</van-button>
                  </div>
                </div>
              </div>
              <div v-else>
                <div style="text-align: left;font-size:16px;color:#000000;">{{youceitem.text}}</div>
                <div style="margin:10px 0px; display: grid;grid-template-columns: 1fr 1fr;">
                  <div style="padding:5px;font-size: 14px;text-align: left;" v-for="(items, key) in youceitem.children" :key="key">
                    <van-button v-if="isValueInArray(youceitem.check,items.id)" plain type="warning" size="small" block style="margin:0px;" @click="xuanzhongitem(index,items.id)">{{items.text}}</van-button>
                    <van-button v-else type="default" size="small" block style="margin:0px;" @click="xuanzhongitem(index,items.id)">{{items.text}}</van-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        </van-tree-select>
      </div>
      <van-sticky :offset-bottom="10" position="bottom">
        <div style="display: grid;grid-template-columns: 1fr 1fr;margin-top: 5px;">
          <div style="padding: 0px 10px;">
            <van-button type="default" block @click="qingkong">清空</van-button>
          </div>
          <div style="padding: 0px 10px;">
            <van-button type="danger" block @click="shaixuan">筛选</van-button>
          </div>
        </div>
      </van-sticky>
  </van-popup>
</div>
  </template>
  <script>
  import { showToast } from 'vant';
  export default {
    name: 'ListPage', // 必须与 keep-alive 的 include 匹配
    data() {
      return {
        list: [],       // 列表数据
        loading: false, // 加载状态
        finished: false,// 是否加载完成
        showBottom: false,
        pageNum:1,
        lunbotu:[],
        gonggao: "",
        activeIndex: 0,
        biaoqianinfo:[],
        activeIds: [],
        scrollTop: 0,
        shaixuanshu:0,
        datainfo:{
          biaoqian:[],
          guanjianci:'',
          bianhao:'',
          zuidijia:'',
          zuigaojia:'',
          paixu:'',
        },
        dakaicishu:0,
      }
    },
    mounted() {
      var that = this;
      that.$emit('child-data', 'xianshi');
      this.$emit('child-title', '工作台');
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'visible') {
          //console.log('页面变得可见！');
          that.$emit('child-data', 'xianshi');
        } else if (document.visibilityState === 'hidden') {
          //console.log('页面变得不可见！');
        }
      });
    },
    created() {
      //this.onLoad();
      document.title = '小徐阁';
      this.getBaseinfo();

      console.log(this.getFromLocalStorage("guanjianci"));
      this.datainfo.guanjianci = this.getFromLocalStorage("guanjianci") != null ? this.getFromLocalStorage("guanjianci") : "";
      this.datainfo.bianhao = this.getFromLocalStorage("bianhao") != null ? this.getFromLocalStorage("bianhao") : "";
      this.datainfo.zuidijia = this.getFromLocalStorage("zuidijia") != null ? this.getFromLocalStorage("zuidijia") : "";
      this.datainfo.zuigaojia = this.getFromLocalStorage("zuigaojia") != null ? this.getFromLocalStorage("zuigaojia") : "";
      this.datainfo.paixu = this.getFromLocalStorage("paixu") != null ? this.getFromLocalStorage("paixu") : "";

      var biaoqianinfo = this.getFromLocalStorage("biaoqianinfo");
      //console.log(this.datainfo);
      if(biaoqianinfo != null)
      {
        this.biaoqianinfo = biaoqianinfo;
        this.zuzhuangshaixuancanshu();
      }
      else
      {
        this.getshaixuan();
      }

      var shaixuanshu = this.getFromLocalStorage("shaixuanshu");
      if(shaixuanshu != null)
      {
        this.shaixuanshu = shaixuanshu;
      }
      
    },
    activated() {
      // 恢复滚动位置
      this.$nextTick(() => {
        const top = this.scrollTop
        document.documentElement.scrollTop = top
        document.body.scrollTop = top // iOS 兼容
      })
    },
    beforeRouteLeave(to, from, next) {
      // 记录离开时的滚动位置
      this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      next()
    },
    methods: {
      onLoad() {
        var that = this;
        this.$http.post('/api/Douyinapi/newShangpinList', {
          datainfo:this.datainfo,
          page:this.pageNum,
        })
        .then(response => {
          if(response.data.code == "true")
            {
              if(response.data.data.total <= 0 && that.dakaicishu <= 0)
              {
                console.log("001");
                showToast('商品已售或不存在');
                that.qingkong();
                console.log("001-1");
              }
              {
                that.dakaicishu = 1;
                that.loading = false;
                that.list = [...that.list, ...response.data.data.data];
                that.pageNum = that.pageNum + 1;
                that.finished = that.pageNum > response.data.data.last_page;
              }
            }
            else
            {
              that.loading = false;
              that.finished = true;
            }
        })
        .catch(error => {
          console.log(error);
          that.loading = false;
          that.finished = true;
        });
      },
      async getshaixuan() {
        this.$http.get('/api/Douyinapi/getAllTags')
        .then(response => {
          if(response.data.code == "true")
          {
            this.biaoqianinfo = response.data.data;
          }
        })
        .catch(error => {
          // 处理错误情况
          console.error("There was an error!", error);
        });
        
      },
      async getBaseinfo() {
        this.$http.get('/api/douyinapi/getBaseInfo')
        .then(response => {
          if(response.data.code == "true")
          {
            this.lunbotu = response.data.data.lunbotu;
            this.gonggao = response.data.data.gonggao;
          }
        })
        .catch(error => {
          // 处理错误情况
          console.error("There was an error!", error);
        });
        
      },
      saveToLocalStorage(key, value) {
        localStorage.setItem(key, JSON.stringify(value));
      },
      getFromLocalStorage(key) {
        const value = localStorage.getItem(key);
        return value ? JSON.parse(value) : null;
      },
      removeLocalStorageItem(key) {
        localStorage.removeItem(key);
      },
      showShaixuan(){
        this.showBottom = true;
      },
      huoquleixing(){
        console.log("2222");
      },
      shuaXin(){
        this.pageNum = 1;
        this.list = [];
        this.onLoad();
      },
      qingkong(){
        this.datainfo.biaoqian = [];
        this.datainfo.guanjianci = '';
        this.datainfo.bianhao = '';
        this.datainfo.zuidijia = '';
        this.datainfo.zuigaojia = '';
        this.datainfo.paixu = 0;
        this.shaixuanshu = 0;
        this.biaoqianinfo.forEach(function (element) {
          element.check = [];
          element.badge = "";
        });
        this.removeLocalStorageItem("biaoqianinfo");
        this.getshaixuan();
        this.shaixuan();
      },
      zuzhuangshaixuancanshu(){
        var that = this;
        that.datainfo.biaoqian = [];
        this.biaoqianinfo.forEach(function (element) {
          that.datainfo.biaoqian = [...that.datainfo.biaoqian, ...element.check];
        });
        that.shaixuanshu = that.datainfo.biaoqian.length;
        this.saveToLocalStorage("biaoqianinfo",this.biaoqianinfo);
        this.saveToLocalStorage("shaixuanshu",this.shaixuanshu);
        this.saveToLocalStorage("guanjianci",this.datainfo.guanjianci);
        this.saveToLocalStorage("bianhao",this.datainfo.bianhao);
        this.saveToLocalStorage("zuidijia",this.datainfo.zuidijia);
        this.saveToLocalStorage("zuigaojia",this.datainfo.zuigaojia);
        this.saveToLocalStorage("paixu",this.datainfo.paixu);
      },
      shaixuan(){
        this.zuzhuangshaixuancanshu();
        this.pageNum = 1;
        this.list = [];
        this.showBottom = false;
        this.onLoad();
      },
      onSearch(){
        this.zuzhuangshaixuancanshu();
        this.pageNum = 1;
        this.list = [];
        this.onLoad();
      },
      onCancel(){
        this.datainfo.guanjianci = '';
      },
      shuzuchangdu(shuzu){
        return shuzu.length;
      },
      isValueInArray(shuzu,value){
        return shuzu.includes(value);
      },
      xuanzhongitem(index,value){
        if(this.isValueInArray(this.biaoqianinfo[index].check,value))
        {
          if(this.biaoqianinfo[index].type == "1")
          {
            this.biaoqianinfo[index].check = [];
          }
          else
          {
            console.log("shanchu");
            this.biaoqianinfo[index].check = this.biaoqianinfo[index].check.filter(item => item !== value);
          }
          
        }
        else
        {
          if(this.biaoqianinfo[index].type == "1")
          {
            this.biaoqianinfo[index].check = [];
            this.biaoqianinfo[index].check.push(value);
          }
          else
          {
            this.biaoqianinfo[index].check.push(value);
          }
        }

        var changdu = this.biaoqianinfo[index].check.length;
        if(changdu > 0)
        {
          this.biaoqianinfo[index].badge = changdu;
        }
        else
        {
          this.biaoqianinfo[index].badge = "";
        }
      },
      goToPage(id){
        this.$router.push({ path: '/detail', query: { id: id } })
        //this.$router.push(`/detail/1`)
      },
      daysAgo(shijian) {
        const dateString = shijian.split(' ')[0];
        const date = new Date(dateString); // 将字符串转换为Date对象
        const now = new Date(); // 获取当前日期和时间
        const diffTime = now - date; // 计算两个日期之间的差异（毫秒）
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // 转换为天数并向上取整以处理非整天数的情况
        return diffDays === 0 ? '今天' : `${diffDays}天前`; // 如果是一天以内，显示“今天”，否则显示天数加“天前”
      },
    }
  }
  </script>
  
  <style>
  .my-swipe .van-swipe-item {
      color: #fff;
      font-size: 20px;
      text-align: center;
      border-radius: 10px;
      overflow: hidden;
    }
    .tongzhibeijing{
      margin: 10px 0px;
      padding: 10px;
      display: grid;
      grid-template-columns: auto 1fr;
      border-radius: 5px;
      background: #ffffff;
    }
    .tongzhizuoce{
      display: flex;justify-content: left;align-items: center;margin-left:5px;border-right: 1px solid #E1E8F6;
      padding-right: 10px;
    }
    .sousuobeijing{
      margin-top: 10px;
      display: grid;
      padding: 8px 0px;
      grid-template-columns:1fr auto auto;
      border-radius: 5px;
      background: #ffffff;
      overflow: hidden;
    }
    .sousuoyouce{
      display: flex;justify-content: left;align-items: center;padding: 0px 10px;
    }
    .goodsname{
      padding: 5px 5px;
      font-size: 14px;
      font-weight: 500;
      color: #333;
      text-align: left;
      margin-bottom: 6px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      height: 40px;
      line-height: 1.5;
    }
    .goods_item_img {
      width: 100%;
      height: 125px;
      border-radius: 5px 0 0 0px;
      display: block;
      object-fit: cover;
    }
    
  </style>
  